import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { TreeNodeMPTEntity } from "../Entity/TreeNodeMPTEntity";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";
import { TreeNodeMessageResultEntity } from "../Entity/TreeNodeMessageResultEntity";
import { EntityEnum } from "../../EntityEnum";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { DateUtil } from "../../../DateUtil";

export class TreeNodeMedicinalProductOperationResult extends Art57NodeList{

    items: any;
    cloningNode: boolean = false;
    entity: string  
    constructor(injector: Injector, parent: any, cloningNode: boolean, items: any[]|undefined, entity: string) {
        super(injector, new ListView(), `${entity==EntityEnum.operationResult?'Operation Results':'All Operation Results'} (${items?items.length:'-'})`);
        this.parent = parent;
        this.entity = entity;
        this.labelNodeName = entity==EntityEnum.operationResult?'Operation Results':'All Operation Results';
        this.items = items;
        this.cloningNode = cloningNode;

        if (this.cloningNode) {
          return;
        }
        for (const item of items || []) {
            this.children?.push(new TreeNodeMessageResultEntity(injector,`${DateUtil.getDateTimeFormat(item.operationdate)} - ${this.ioc?.get(LookupGetService).retrieveValueFromCache('operationtypeoperationresult', item.operationtype)} - ${this.ioc?.get(LookupGetService).retrieveValueFromCache('operationresult',item.operationresult)}`,this,item));
        }
    }

    override getHeaders(): string[] {
        return ['Entity','Local Number','EV Code','Operation Type','Operation Result','Operation Date','Message'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductOperationResult = new TreeNodeMedicinalProductOperationResult(
        this.ioc!,
        newParent,
        true,
        this.items,
        this.entity
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }
    
    
}